"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommsMessages = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const WhatsAppAgentService_1 = __importStar(require("@front/services/WhatsAppAgentService"));
//@ts-ignore                
let rwsTemplate = T.html `<section class="card border-0 shadow-sm mb-4">
    <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3">
        <div class="d-flex align-items-center" style="gap: 8px;">
            <i class="iconsminds-speach-bubbles text-success" style="font-size: 1.1rem;"></i>
            <h2 class="h6 mb-0 font-weight-bold text-uppercase text-dark" style="font-size: 0.8rem;">${x => x.mode === 'dm' ? 'whatsapp.dm.messages'.t() : 'whatsapp.groups.messages'.t()}</h2>
        </div>
        <span class="text-success font-weight-bold d-inline-block" style="background-color: rgba(40, 167, 69, 0.1); border: 1px solid rgba(40, 167, 69, 0.25); border-radius: 12px; padding: 2px 10px; font-size: 0.7rem;">${x => x.communicationType === 'TELE' ? 'Telegram' : 'WhatsApp'}</span>
    </div>

    
    ${(0, fast_element_1.when)(x => !x.isPreviewMode, (0, fast_element_1.html) `
    <div class="comms-messages-controls border-bottom px-3 py-2 bg-white">
        <div class="d-flex align-items-center mb-2">
            <label class="mb-0 mr-2 text-muted small"><i class="simple-icon-calendar mr-1"></i>${x => x.mode === 'dm' ? 'whatsapp.dm.dateFrom'.t() : 'whatsapp.groups.dateFrom'.t()}</label>
            <input type="date" class="form-control form-control-sm" style="width: auto"
                   :value="${x => x.dateFrom}"
                   @change="${(x, c) => x.handleDateFromChange(c.event)}" />
            <label class="mb-0 mx-2 text-muted small">${x => x.mode === 'dm' ? 'whatsapp.dm.dateTo'.t() : 'whatsapp.groups.dateTo'.t()}</label>
            <input type="date" class="form-control form-control-sm" style="width: auto"
                   :value="${x => x.dateTo}"
                   @change="${(x, c) => x.handleDateToChange(c.event)}" />
        </div>
        <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-outline-info btn-sm"
                    @click="${x => x.summarizeMessages()}"
                    ?disabled="${x => x.summarizing || !x.agentActive || x.messages.length === 0}">
                ${(0, fast_element_1.when)(x => x.summarizing, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                ${(0, fast_element_1.when)(x => !x.summarizing, (0, fast_element_1.html) `<i class="simple-icon-doc mr-1"></i>`)}
                ${x => x.mode === 'dm' ? 'whatsapp.dm.summarize'.t() : 'whatsapp.groups.summarize'.t()}
            </button>
            <button type="button" class="ml-2 btn btn-outline-secondary btn-sm"
                    @click="${x => x.syncMessages()}"
                    ?disabled="${x => x.syncingMessages || !x.agentActive}">
                ${(0, fast_element_1.when)(x => x.syncingMessages, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                ${(0, fast_element_1.when)(x => !x.syncingMessages, (0, fast_element_1.html) `<i class="simple-icon-refresh mr-1"></i>`)}
                ${x => x.mode === 'dm' ? 'whatsapp.dm.syncMessages.button'.t() : 'whatsapp.groups.syncMessages.button'.t()}
            </button>
        </div>
    </div>
    `)}

    
    <div class="comms-messages-list p-3">
        ${(0, fast_element_1.when)(x => x.messagesLoading, (0, fast_element_1.html) `
            <div class="text-center p-3"><app-loader block="true" width="15px" height="15px"></app-loader></div>
        `)}
        ${(0, fast_element_1.when)(x => !x.messagesLoading && x.filteredMessages.length === 0, (0, fast_element_1.html) `
            <p class="text-muted text-center p-4">${x => x.mode === 'dm' ? 'whatsapp.dm.noMessages'.t() : 'whatsapp.groups.noMessages'.t()}</p>
        `)}
        ${(0, fast_element_1.when)(x => !x.messagesLoading && x.filteredMessages.length > 0, (0, fast_element_1.html) `
            <div ${(0, fast_element_1.ref)('messagesScrollContainer')} class="messages-list" @scroll="${(x, c) => x.handleMessagesScroll(c.event)}">
                ${(0, fast_element_1.repeat)(x => x.filteredMessages, (0, fast_element_1.html) `
                    <div class="message-item ${x => x.isFromAgent ? 'message-item--agent' : ''}">
                        <div class="message-item__meta">
                            <span class="message-item__sender">${(x, c) => c.parent.getSenderName(x)}</span>
                            <span class="message-item__time">${(x, c) => c.parent.formatDate(x.timestamp)}</span>
                        </div>
                        <div class="message-item__body">${x => x.messageContent}</div>
                        ${(0, fast_element_1.when)(x => !!x.mediaType, (0, fast_element_1.html) `
                            <div class="message-item__media mt-1">
                                <span class="text-muted small mr-2">
                                    <i class="simple-icon-paper-clip mr-1"></i>${x => x.mode === 'dm' ? 'whatsapp.dm.media.attachment'.t() : 'whatsapp.groups.media.attachment'.t()} (${x => x.mediaType || ''})
                                </span>
                                <button type="button" class="btn btn-outline-secondary btn-xs"
                                        ?disabled="${(x, c) => !!c.parent.downloadingMediaId}"
                                        @click="${(x, c) => c.parent.downloadMedia(x)}">
                                    ${(0, fast_element_1.when)((x, c) => c.parent.downloadingMediaId === x.id, (0, fast_element_1.html) `
                                        <app-loader block="true" width="10px" height="10px"></app-loader>
                                        ${x => x.mode === 'dm' ? 'whatsapp.dm.media.downloading'.t() : 'whatsapp.groups.media.downloading'.t()}
                                    `)}
                                    ${(0, fast_element_1.when)((x, c) => c.parent.downloadingMediaId !== x.id, (0, fast_element_1.html) `
                                        <i class="simple-icon-cloud-download mr-1"></i>${x => x.mode === 'dm' ? 'whatsapp.dm.media.download'.t() : 'whatsapp.groups.media.download'.t()}
                                    `)}
                                </button>
                            </div>
                        `)}
                    </div>
                `)}
            </div>
        `)}
    </div>

    
    
    <div class="chat-drawer-footer">
        <form class="input-group" @submit="${(x, c) => { c.event.preventDefault(); x.sendMessage(); }}">
            <input type="text" class="form-control"
                   :placeholder="${x => x.mode === 'dm' ? 'whatsapp.dm.sendMessage.placeholder'.t() : 'whatsapp.groups.sendMessage.placeholder'.t()}"
                   :value="${x => x.outgoingMessage}"
                   @input="${(x, c) => x.handleOutgoingMessageInput(c.event)}"
                   ?disabled="${x => x.sendingMessage || !x.agentActive}" />
            <div class="input-group-append">
                <button type="submit" class="btn btn-success d-flex align-items-center justify-content-center px-3"
                        ?disabled="${x => x.sendingMessage || !x.agentActive || !x.outgoingMessage}">
                    ${(0, fast_element_1.when)(x => x.sendingMessage, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                    ${(0, fast_element_1.when)(x => !x.sendingMessage, (0, fast_element_1.html) `<i class="simple-icon-paper-plane"></i>`)}
                </button>
            </div>
        </form>
    </div>
    
</section>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.messages-list {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.messages-list .message-item:nth-child(odd) {
  background-color: rgb(243, 243, 243) !important;
}

.message-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.message-item:last-child {
  border-bottom: none;
}
.message-item--agent {
  background-color: rgba(40, 167, 69, 0.05) !important;
  border-left: 3px solid #28a745;
}
.message-item__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.message-item__sender {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}
.message-item__time {
  font-size: 11px;
  color: #999;
}
.message-item__body {
  font-size: 14px;
  color: #555;
  word-break: break-word;
}

.chat-drawer-footer {
  padding: 1rem;
  background: #fff;
  border-top: 1px solid #e9ecef;
}

.comms-messages-controls .btn {
  font-size: 0.8rem;
}`;
const shadowOptions = { "mode": "open" };
let CommsMessages = class CommsMessages extends client_1.RWSViewComponent {
    constructor(wsService, waAgentService) {
        super();
        this.wsService = wsService;
        this.waAgentService = waAgentService;
        /** 'group' for group messages, 'dm' for direct messages */
        this.mode = 'group';
        /** Group ID (required for mode='group') */
        this.groupId = '';
        /** WhatsApp Group ID for WS event matching (optional, falls back to groupId) */
        this.groupWaId = '';
        /** Settings ID (required for mode='dm') */
        this.settingsId = '';
        /** Author LID (required for mode='dm') */
        this.authorLid = '';
        /** Communication type: 'WA' or 'TELE' */
        this.communicationType = 'WA';
        /** Whether the agent is active */
        this.agentActive = false;
        /** Contact name for DM mode */
        this.contactName = '';
        /** Max messages to load (read-only preview mode when set) */
        this.maxMsg = '';
        /** Whether this is in preview/read-only mode */
        this.isPreviewMode = false;
        this.messages = [];
        this.filteredMessages = [];
        this.messagesLoading = false;
        this.syncingMessages = false;
        this.summarizing = false;
        this.sendingMessage = false;
        this.outgoingMessage = '';
        this.dateFrom = new Date().toISOString().slice(0, 10);
        this.dateTo = new Date().toISOString().slice(0, 10);
        this.downloadingMediaId = '';
        this.messagesScrollContainer = null;
        this._shouldAutoScroll = true;
        this._wsUnsubscribers = [];
    }
    async connectedCallback() {
        super.connectedCallback();
        // this.isPreviewMode = !!this.maxMsg && Number(this.maxMsg) > 0;
        if (this.mode === 'group' && this.groupId && (!this.groupWaId || !this.settingsId)) {
            await this.loadGroupDetails();
        }
        await this.loadMessages();
        this.setupWsListeners();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._wsUnsubscribers.forEach(off => off());
        this._wsUnsubscribers = [];
    }
    setupWsListeners() {
        if (this.mode === 'group') {
            this.setupGroupWsListeners();
        }
        else {
            this.setupDmWsListeners();
        }
    }
    /**
     * Returns the WA ID used for WS event matching.
     * Falls back to groupId if groupWaId is not set.
     */
    get effectiveGroupWaId() {
        return this.groupWaId || this.groupId;
    }
    setupGroupWsListeners() {
        // New group message
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const payload = wsResponse.data;
            if (payload && payload.groupWaId === this.effectiveGroupWaId && String(payload.settingsId) === this.settingsId) {
                this.loadMessages();
            }
        }, 'comms_new_group_message'));
        // Sync messages result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', async (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== this.effectiveGroupWaId || (data.settingsId && String(data.settingsId) !== this.settingsId))
                return;
            this.syncingMessages = false;
            if (data.success) {
                await this.loadMessages();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.syncMessages.failed'.t(), 'error');
            }
        }, 'comms_sync_messages_result'));
        // Summarize result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== this.effectiveGroupWaId || (data.settingsId && String(data.settingsId) !== this.settingsId))
                return;
            this.summarizing = false;
            if (data.success && data.summaryText) {
                this.notifyService.notify('whatsapp.groups.summarizeDone'.t(), 'info');
                this.$emit('summary-created', { summaryId: data.id, summaryText: data.summaryText });
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.summarizeFailed'.t(), 'error');
            }
        }, 'comms_summarize_result'));
        // Send message result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.groupWaId !== this.effectiveGroupWaId || (data.settingsId && String(data.settingsId) !== this.settingsId))
                return;
            this.sendingMessage = false;
            if (data.success) {
                this.outgoingMessage = '';
                this.notifyService.notify('whatsapp.groups.sendMessage.success'.t(), 'info');
                this.loadMessages();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.sendMessage.failed'.t(), 'error');
            }
        }, 'comms_send_message_result'));
    }
    setupDmWsListeners() {
        // New DM message
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', async (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.authorLid !== this.authorLid)
                return;
            await this.loadMessages();
        }, 'comms_new_dm_message'));
        // DM sync messages result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', async (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.authorLid !== this.authorLid)
                return;
            this.syncingMessages = false;
            if (data.success) {
                await this.loadMessages();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.dm.syncMessages.failed'.t(), 'error');
            }
        }, 'comms_dm_sync_messages_result'));
        // DM summarize result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.authorLid !== this.authorLid)
                return;
            this.summarizing = false;
            if (data.success && data.summaryText) {
                this.notifyService.notify('whatsapp.dm.summarizeDone'.t(), 'info');
                this.$emit('summary-created', { summaryId: data.id, summaryText: data.summaryText });
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.dm.summarizeFailed'.t(), 'error');
            }
        }, 'comms_dm_summarize_result'));
        // DM send message result
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.authorLid !== this.authorLid)
                return;
            this.sendingMessage = false;
            if (data.success) {
                this.notifyService.notify('whatsapp.dm.sendMessage.success'.t(), 'info');
                this.outgoingMessage = '';
                this.loadMessages();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.dm.sendMessage.failed'.t(), 'error');
            }
        }, 'comms_dm_send_message_result'));
    }
    async loadMessages() {
        this.messagesLoading = true;
        try {
            if (this.mode === 'group') {
                await this.loadGroupMessages();
            }
            else {
                await this.loadDmMessages();
            }
        }
        catch (e) {
            console.error(e);
            this.messages = [];
        }
        finally {
            this.messagesLoading = false;
            this.scrollMessagesToBottom();
        }
    }
    async loadGroupDetails() {
        try {
            const response = await this.apiService.back.get('whatsapp.groups.get', {
                routeParams: { id: this.groupId }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                if (!this.groupWaId && response.data.groupWaId) {
                    this.groupWaId = response.data.groupWaId;
                }
                if (!this.settingsId && response.data.settingsId) {
                    this.settingsId = String(response.data.settingsId);
                }
            }
        }
        catch (e) {
            console.error('Failed to load group details', e);
        }
    }
    async loadGroupMessages() {
        const routeOptions = {
            routeParams: { id: this.groupId }
        };
        const queryParams = {};
        if (this.dateFrom && !this.isPreviewMode)
            queryParams.dateFrom = this.dateFrom;
        if (this.dateTo && !this.isPreviewMode)
            queryParams.dateTo = this.dateTo;
        if (this.maxMsg) {
            queryParams.limit = this.maxMsg;
        }
        if (Object.keys(queryParams).length > 0) {
            routeOptions.queryParams = queryParams;
        }
        const response = await this.apiService.back.get('whatsapp.groups.messages', routeOptions);
        if (response && response.success && Array.isArray(response.data)) {
            this.messages = response.data;
            this.filteredMessages = response.data;
        }
    }
    async loadDmMessages() {
        const routeParams = {
            settingsId: this.settingsId,
            authorLid: encodeURIComponent(this.authorLid)
        };
        const queryParams = {};
        if (this.dateFrom && !this.isPreviewMode)
            queryParams.dateFrom = this.dateFrom;
        if (this.dateTo && !this.isPreviewMode)
            queryParams.dateTo = this.dateTo;
        if (this.maxMsg) {
            queryParams.limit = this.maxMsg;
        }
        const response = await this.apiService.back.get('whatsapp.directMessages.messages', { routeParams, queryParams });
        if ((response === null || response === void 0 ? void 0 : response.success) && Array.isArray(response.data)) {
            this.messages = response.data;
            this.filteredMessages = response.data;
            // Discover contact name from messages and emit event
            if (!this.contactName && this.messages.length > 0) {
                const incoming = this.messages.find(m => !m.isFromAgent);
                const outgoing = this.messages.find(m => m.isFromAgent);
                const discoveredName = (incoming === null || incoming === void 0 ? void 0 : incoming.senderName) || (outgoing === null || outgoing === void 0 ? void 0 : outgoing.recipientName) || '';
                if (discoveredName) {
                    this.contactName = discoveredName;
                    this.$emit('contact-name-discovered', { contactName: discoveredName });
                }
            }
        }
        else {
            this.messages = [];
            this.filteredMessages = [];
        }
    }
    messagesChanged() {
        setTimeout(() => {
            this.scrollMessagesToBottom();
        }, 200);
    }
    handleMessagesScroll(event) {
        const container = event.target;
        const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        this._shouldAutoScroll = distanceFromBottom < 100;
    }
    scrollMessagesToBottom() {
        if (!this._shouldAutoScroll)
            return;
        const container = this.messagesScrollContainer;
        if (!container)
            return;
        container.scrollTop = container.scrollHeight;
    }
    handleDateFromChange(event) {
        this.dateFrom = event.target.value;
        this.loadMessages();
    }
    handleDateToChange(event) {
        this.dateTo = event.target.value;
        this.loadMessages();
    }
    dateFromChanged() {
        this.loadMessages();
    }
    dateToChanged() {
        this.loadMessages();
    }
    async syncMessages() {
        if (this.mode === 'group') {
            await this.syncGroupMessages();
        }
        else {
            await this.syncDmMessages();
        }
    }
    async syncGroupMessages() {
        this.syncingMessages = true;
        try {
            const response = await this.apiService.back.post('whatsapp.groups.syncMessages', {}, {
                routeParams: { id: this.groupId }
            });
            if (!response || !response.success) {
                this.syncingMessages = false;
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.syncMessages.failed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.syncingMessages = false;
            this.notifyService.notify('whatsapp.groups.syncMessages.failed'.t(), 'error');
        }
    }
    async syncDmMessages() {
        if (!this.settingsId)
            return;
        this.syncingMessages = true;
        try {
            const response = await this.apiService.back.post('whatsapp.directMessages.syncMessages', {}, {
                routeParams: {
                    settingsId: this.settingsId,
                    authorLid: encodeURIComponent(this.authorLid)
                }
            });
            if (!response || !response.success) {
                this.syncingMessages = false;
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.dm.syncMessages.failed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.syncingMessages = false;
            this.notifyService.notify('whatsapp.dm.syncMessages.failed'.t(), 'error');
        }
    }
    summarizeMessages() {
        if (this.mode === 'group') {
            this.summarizeGroupMessages();
        }
        else {
            this.summarizeDmMessages();
        }
    }
    summarizeGroupMessages() {
        this.summarizing = true;
        this.wsService.sendMessage('comms_point', 'comms_summarize', {
            settingsId: this.settingsId,
            groupWaId: this.effectiveGroupWaId,
            date: this.dateFrom,
            dateTo: this.dateTo
        });
    }
    async summarizeDmMessages() {
        this.summarizing = true;
        try {
            const response = await this.apiService.back.post('whatsapp.directMessages.summarize', { date: this.dateFrom, dateTo: this.dateTo }, {
                routeParams: {
                    settingsId: this.settingsId,
                    authorLid: encodeURIComponent(this.authorLid)
                }
            });
            if (!response || !response.success) {
                this.summarizing = false;
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.dm.summarizeFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.summarizing = false;
            this.notifyService.notify('whatsapp.dm.summarizeFailed'.t(), 'error');
        }
    }
    handleOutgoingMessageInput(event) {
        this.outgoingMessage = event.target.value;
    }
    async sendMessage() {
        if (!this.outgoingMessage.trim())
            return;
        if (this.mode === 'group') {
            await this.sendGroupMessage();
        }
        else {
            await this.sendDmMessage();
        }
    }
    async sendGroupMessage() {
        this.sendingMessage = true;
        try {
            this.wsService.sendMessage('comms_point', 'comms_send_message', {
                settingsId: this.settingsId,
                groupWaId: this.effectiveGroupWaId,
                message: this.outgoingMessage.trim()
            });
        }
        catch (e) {
            console.error(e);
            this.sendingMessage = false;
            this.notifyService.notify('whatsapp.groups.sendMessage.failed'.t(), 'error');
        }
    }
    async sendDmMessage() {
        if (!this.settingsId)
            return;
        this.sendingMessage = true;
        try {
            this.wsService.sendMessage('comms_point', 'comms_dm_send_message', {
                settingsId: this.settingsId,
                authorLid: this.authorLid,
                message: this.outgoingMessage.trim()
            });
        }
        catch (e) {
            console.error(e);
            this.sendingMessage = false;
            this.notifyService.notify('whatsapp.dm.sendMessage.failed'.t(), 'error');
        }
    }
    async downloadMedia(message) {
        if (!message.id || this.downloadingMediaId)
            return;
        this.downloadingMediaId = message.id;
        try {
            const token = localStorage.getItem('jwt_token') || '';
            const response = await fetch(`/api/whatsapp/messages/${message.id}/download-media`, { headers: { Authorization: `Bearer ${token}` } });
            if (!response.ok) {
                const body = await response.json().catch(() => ({}));
                throw new Error((body === null || body === void 0 ? void 0 : body.message) || 'Download failed');
            }
            const blob = await response.blob();
            const cd = response.headers.get('Content-Disposition') || '';
            const match = cd.match(/filename[^;=\n]*=(['"]?)([^'"\n;]*)\1/);
            const filename = match ? match[2].trim() : (message.waId || message.id);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify(this.mode === 'dm' ? 'whatsapp.dm.media.downloadFailed'.t() : 'whatsapp.groups.media.downloadFailed'.t(), 'error');
        }
        finally {
            this.downloadingMediaId = '';
        }
    }
    /**
     * Public method for external callers to force a reload of messages.
     * Useful when the parent changes the groupId/authorLid and needs
     * the component to re-fetch with the new parameters.
     */
    async reload() {
        this.messages = [];
        this.filteredMessages = [];
        await this.loadMessages();
    }
    formatDate(isoString) {
        if (!isoString)
            return '';
        return new Date(isoString).toLocaleString();
    }
    getSenderName(message) {
        if (this.mode === 'dm') {
            return message.isFromAgent ? 'whatsapp.dm.botSender'.t() : (this.contactName || message.senderName || '');
        }
        return message.senderName || message.memberId || message.memberPhone || '';
    }
};
exports.CommsMessages = CommsMessages;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "mode", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "groupId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "groupWaId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "settingsId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "authorLid", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "communicationType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "agentActive", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "contactName", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsMessages.prototype, "maxMsg", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "isPreviewMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CommsMessages.prototype, "messages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CommsMessages.prototype, "filteredMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "messagesLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "syncingMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "summarizing", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsMessages.prototype, "sendingMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsMessages.prototype, "outgoingMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsMessages.prototype, "dateFrom", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsMessages.prototype, "dateTo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsMessages.prototype, "downloadingMediaId", void 0);
exports.CommsMessages = CommsMessages = __decorate([
    (0, client_1.RWSView)('comms-messages', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(1, (0, client_1.RWSInject)(WhatsAppAgentService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WhatsAppAgentService_1.WhatsAppAgentServiceInstance !== "undefined" && WhatsAppAgentService_1.WhatsAppAgentServiceInstance) === "function" ? _b : Object])
], CommsMessages);
CommsMessages.defineComponent();
exports.default = CommsMessages;
